import { render, staticRenderFns } from "./ConfigQuestionSwitchDetail.vue?vue&type=template&id=21843c84&scoped=true&"
import script from "./ConfigQuestionSwitchDetail.vue?vue&type=script&lang=js&"
export * from "./ConfigQuestionSwitchDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConfigQuestionSwitchDetail.vue?vue&type=style&index=0&id=21843c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21843c84",
  null
  
)

export default component.exports